import Loader from "@amzn/meridian/loader";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Theme from "@amzn/meridian/theme";
import { observer } from "mobx-react-lite";
import React from "react";

import { GreenLoaderTokens, PrimaryGreenColorToken } from "../utils/Tokens";

export interface IConstraintLoaderProps {
  characterLength: number;
  maximumCharacterLength: number;
}

export const ConstraintLoader = ({
  characterLength,
  maximumCharacterLength,
}: IConstraintLoaderProps): React.JSX.Element => {
  return (
    <Row spacingInset="300 none none" data-testid="constraintloader-container-row">
      <Theme
        tokens={
          characterLength === maximumCharacterLength && GreenLoaderTokens
        }
      >
        <Loader
          percentage={(characterLength / maximumCharacterLength) * 100}
          data-testid="constraintloader-progress-loader"
          size="small"
          showPercentageText={false}
        />
      </Theme>
      <Theme
        tokens={
          characterLength === maximumCharacterLength && PrimaryGreenColorToken
        }
      >
        <Text type="b100" data-testid="constraintloader-character-count-text">
          {`${characterLength} / ${maximumCharacterLength} Characters`}
        </Text>
      </Theme>
    </Row>
  );
};

export default observer(ConstraintLoader);
